import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center py-20"
}
const _hoisted_9 = { class: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-6" }
const _hoisted_10 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5 mb-6" }
const _hoisted_11 = { class: "text-base font-bold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_12 = { class: "h-64" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" }
const _hoisted_14 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5" }
const _hoisted_15 = { class: "text-base font-bold text-dashboard-text mb-1 flex items-center gap-2" }
const _hoisted_16 = { class: "ml-auto text-sm font-semibold text-dashboard-muted" }
const _hoisted_17 = { class: "h-60" }
const _hoisted_18 = {
  key: 1,
  class: "h-full flex items-center justify-center text-sm text-dashboard-muted"
}
const _hoisted_19 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5" }
const _hoisted_20 = { class: "text-base font-bold text-dashboard-text mb-1 flex items-center gap-2" }
const _hoisted_21 = { class: "ml-auto text-sm font-semibold text-dashboard-muted" }
const _hoisted_22 = { class: "h-60" }
const _hoisted_23 = { class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5 mb-6" }
const _hoisted_24 = { class: "text-base font-bold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_25 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-3" }
const _hoisted_26 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6"
}
const _hoisted_27 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_28 = {
  key: 0,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5"
}
const _hoisted_29 = { class: "text-base font-bold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_30 = { class: "h-52" }
const _hoisted_31 = {
  key: 1,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm p-5"
}
const _hoisted_32 = { class: "text-base font-bold text-dashboard-text mb-1 flex items-center gap-2" }
const _hoisted_33 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_34 = { class: "h-52" }
const _hoisted_35 = { class: "h-52" }
const _hoisted_36 = {
  key: 2,
  class: "bg-white border border-dashboard-border rounded-xl p-12 text-center"
}

import { ref, computed, h, type FunctionalComponent } from 'vue'
import {
  LayoutDashboard, RefreshCw, AlertCircle, TrendingUp, Search,
  Layers, Inbox, Send, FolderKanban, ArrowLeftRight, Archive, Upload,
  Building2, FileText, FileSpreadsheet,
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import StatsFilterBar from '@/components/dashboard/StatsFilterBar.vue'
import ExportModal from '@/components/dashboard/ExportModal.vue'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import { Doughnut, Bar } from 'vue-chartjs'
import {
  Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend,
} from 'chart.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboard',
  setup(__props) {

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const toast = useToast()
const loading = ref(false)
const overview = ref<any>(null)
const courriers = ref<any>(null)
const departs = ref<any>(null)
const affectations = ref<any>(null)
const currentParams = ref<Record<string, string>>({})
const showExport = ref(false)

const stageRows = computed(() =>
  (overview.value?.par_etape || []).map((s: any) => ({ label: s.label, count: s.count })),
)

// Libellés FR des vrais statuts de Note (champ libre côté backend)
const NOTE_STATUS_LABELS: Record<string, string> = {
  draft: 'Brouillon',
  brouillon: 'Brouillon',
  en_validation: 'En validation',
  en_attente_validation: 'En attente de validation',
  validee: 'Validée',
  valide: 'Validée',
  rejetee: 'Rejetée',
  finalisee: 'Finalisée',
  en_attente_archivage: "En attente d'archivage",
  archive: 'Archivée',
  archived: 'Archivée',
}
const noteStatusLabel = (s: string) =>
  NOTE_STATUS_LABELS[(s || '').toLowerCase().trim()] || s || '—'

// Libellés FR des statuts d'Affectation (cf. Affectation.STATUT_CHOICES)
const AFFECTATION_STATUS_LABELS: Record<string, string> = {
  masque: 'Masquée',
  en_attente: 'En attente',
  accepte: 'Acceptée',
  en_rédaction: 'En rédaction',
  en_traitement: 'En traitement',
  en_consultation: 'En consultation',
  traite: 'Traitée',
  rejete: 'Rejetée',
  transferee: 'Transférée',
}
const affectationStatusLabel = (s: string) =>
  AFFECTATION_STATUS_LABELS[(s || '').toLowerCase().trim()] || s || '—'
const affectationStatusRows = computed(() =>
  (affectations.value?.par_statut || []).map((r: any) => ({
    label: affectationStatusLabel(r.statut),
    count: r.count,
  })),
)

// Donut « Notes par statut » — état courant de toutes les notes du périmètre
// (overview.departs_par_statut) pour que la somme = courriers départ (),
// au lieu de departs.par_statut qui est filtré par période de création.
const noteStatusRows = computed(() =>
  (overview.value?.departs_par_statut || []).map((r: any) => ({
    label: noteStatusLabel(r.statut),
    count: r.count,
  })),
)

// Donut « Répartition par étape »
const STAGE_COLORS = [
  '#22282F', '#4f46e5', '#7c3aed', '#d97706',
  '#0891b2', '#059669', '#dc2626', '#64748b', '#9ca3af',
]
const hasStageData = computed(() => stageRows.value.some((r) => r.count > 0))
const stageDonutData = computed(() => ({
  labels: stageRows.value.map((r) => r.label),
  datasets: [
    {
      data: stageRows.value.map((r) => r.count),
      backgroundColor: stageRows.value.map((_, i) => STAGE_COLORS[i % STAGE_COLORS.length]),
      borderWidth: 0,
    },
  ],
}))
const donutOptions: any = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '62%',
  plugins: {
    legend: {
      position: 'right',
      labels: { boxWidth: 12, padding: 12, font: { size: 11 } },
    },
    tooltip: {
      callbacks: {
        label: (ctx: any) => `${ctx.label}: ${ctx.parsed}`,
      },
    },
  },
}

function qs(params: Record<string, string>) {
  return new URLSearchParams(params).toString()
}

async function fetchAll(params: Record<string, string>) {
  loading.value = true
  const query = qs(params)
  try {
    const [ov, co, de, af] = await Promise.all([
      apiFetch(`/api/admin/stats/overview/?${query}`),
      apiFetch(`/api/admin/stats/courriers/?${query}`),
      apiFetch(`/api/admin/stats/departs/?${query}`),
      apiFetch(`/api/admin/stats/affectations/?${query}`),
    ])
    overview.value = ov
    courriers.value = co
    departs.value = de
    affectations.value = af
  } catch (e) {
    toast.error('Erreur', 'Impossible de charger les statistiques')
  } finally {
    loading.value = false
  }
}

function onFilterChange(params: Record<string, string>) {
  currentParams.value = params
  fetchAll(params)
}

function reload() {
  fetchAll(currentParams.value)
}

function onExportDone(count: number) {
  toast.success('Export Excel', `${count} feuille(s) exportée(s).`)
}

// ── Petits composants présentation (functional, inline) ───────────────
const toneMap: Record<string, string> = {
  slate: 'bg-gray-100 text-gray-800',
  indigo: 'bg-indigo-50 text-indigo-700',
  violet: 'bg-violet-50 text-violet-700',
  amber: 'bg-amber-50 text-amber-700',
  cyan: 'bg-cyan-50 text-cyan-700',
  emerald: 'bg-emerald-50 text-emerald-700',
}

const KpiCard: FunctionalComponent<{ icon: any; label: string; value: number; tone: string }> = (props) =>
  h('div', { class: 'bg-white border border-dashboard-border rounded-xl shadow-sm p-4' }, [
    h('div', { class: `inline-flex p-2 rounded-lg mb-2 ${toneMap[props.tone] || toneMap.slate}` }, [
      h(props.icon, { class: 'w-5 h-5' }),
    ]),
    h('p', { class: 'text-2xl font-bold text-dashboard-text' }, String(props.value ?? 0)),
    h('p', { class: 'text-xs text-dashboard-muted' }, props.label),
  ])

const MiniStat: FunctionalComponent<{ label: string; value: any }> = (props) =>
  h('div', { class: 'bg-dashboard-bg rounded-lg p-3' }, [
    h('p', { class: 'text-lg font-bold text-dashboard-text' }, String(props.value ?? 0)),
    h('p', { class: 'text-xs text-dashboard-muted' }, props.label),
  ])

// ── Données dérivées + composants graphiques ──────────────────────────
// Progression des courriers = état courant (Courrier.status normalisé), ordonné
// en entonnoir. Source fiable & toujours cohérente (exclut les supprimés),
// contrairement au registre d'événements qui ne se remplit qu'en avant.
const PARCOURS_ORDER = [
  'brouillon', 'en_attente', 'envoye_sg', 'chez_ambassadeur', 'affecte',
  'en_traitement', 'valide', 'en_attente_archivage', 'archive',
]
const journeyRows = computed(() => {
  const stages = overview.value?.par_etape || []
  const byStage: Record<string, any> = {}
  for (const s of stages) byStage[s.stage] = s
  const rows = PARCOURS_ORDER
    .filter((st) => byStage[st])
    .map((st) => ({ label: byStage[st].label, count: byStage[st].count }))
  // Stages hors entonnoir connu (ex. « inconnu ») ajoutés en fin.
  for (const s of stages) {
    if (!PARCOURS_ORDER.includes(s.stage)) rows.push({ label: s.label, count: s.count })
  }
  return rows
})
const actorRows = (rows: any[]) =>
  (rows || []).map((r) => ({ label: r.full_name || r.username || '—', count: r.count }))

const PALETTE = [
  '#22282F', '#4f46e5', '#7c3aed', '#d97706', '#0891b2',
  '#059669', '#dc2626', '#0ea5e9', '#65a30d', '#64748b', '#9ca3af',
]
const barVOptions: any = {
  responsive: true, maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: { y: { beginAtZero: true, ticks: { precision: 0 } }, x: { ticks: { font: { size: 10 } } } },
}
const barHOptions: any = {
  responsive: true, maintainAspectRatio: false, indexAxis: 'y',
  plugins: { legend: { display: false } },
  scales: { x: { beginAtZero: true, ticks: { precision: 0 } }, y: { ticks: { font: { size: 11 } } } },
}
const rowsHaveData = (rows: any[]) => Array.isArray(rows) && rows.some((r) => (r.count || 0) > 0)
const emptyChart = () =>
  h('div', { class: 'h-full flex items-center justify-center text-sm text-dashboard-muted' }, 'Aucune donnée')

const ChartCard: FunctionalComponent<{ title: string; icon: any }> = (props, { slots }) =>
  h('div', { class: 'bg-white border border-dashboard-border rounded-xl shadow-sm p-5' }, [
    h('h3', { class: 'text-base font-bold text-dashboard-text mb-4 flex items-center gap-2' }, [
      h(props.icon, { class: 'w-5 h-5 text-[#22282F]' }), props.title,
    ]),
    h('div', { class: 'h-60' }, slots.default ? slots.default() : []),
  ])

const ChartDonut: FunctionalComponent<{ rows: any[] }> = (props) =>
  rowsHaveData(props.rows)
    ? h(Doughnut, {
        data: {
          labels: props.rows.map((r) => r.label),
          datasets: [{
            data: props.rows.map((r) => r.count),
            backgroundColor: props.rows.map((_, i) => PALETTE[i % PALETTE.length]),
            borderWidth: 0,
          }],
        },
        options: donutOptions,
      })
    : emptyChart()

const ChartBar: FunctionalComponent<{ rows: any[]; horizontal?: boolean; color?: string }> = (props) =>
  rowsHaveData(props.rows)
    ? h(Bar, {
        data: {
          labels: props.rows.map((r) => r.label),
          datasets: [{
            data: props.rows.map((r) => r.count),
            backgroundColor: props.color || '#22282F',
            borderRadius: 4, borderWidth: 0, maxBarThickness: 30,
          }],
        },
        options: props.horizontal ? barHOptions : barVOptions,
      })
    : emptyChart()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(LayoutDashboard), { class: "w-8 h-8 text-[#22282F]" })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", null, [
              _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-dashboard-text" }, "Tableau de bord"),
              _createElementVNode("p", { class: "text-dashboard-muted text-sm mt-0.5" }, "Pilotage de l'activité — courriers, affectations, archives")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showExport.value = true)),
              disabled: loading.value || !overview.value,
              class: "px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex items-center gap-2 disabled:opacity-50"
            }, [
              _createVNode(_unref(FileSpreadsheet), { class: "w-4 h-4" }),
              _cache[3] || (_cache[3] = _createTextVNode(" Exporter Excel "))
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              onClick: reload,
              disabled: loading.value,
              class: "px-4 py-2 bg-[#22282F] text-white rounded-lg hover:bg-[#2a3139] transition-colors flex items-center gap-2 disabled:opacity-50"
            }, [
              _createVNode(_unref(RefreshCw), {
                class: _normalizeClass(['w-4 h-4', loading.value && 'animate-spin'])
              }, null, 8, ["class"]),
              _cache[4] || (_cache[4] = _createTextVNode(" Actualiser "))
            ], 8, _hoisted_7)
          ])
        ]),
        _createVNode(StatsFilterBar, { onChange: onFilterChange }),
        (loading.value && !overview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", { class: "w-12 h-12 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin mx-auto mb-4" }),
                _createElementVNode("p", { class: "text-dashboard-muted" }, "Chargement des statistiques...")
              ], -1)
            ])))
          : (overview.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(KpiCard, {
                    icon: _unref(Layers),
                    label: "Documents (total)",
                    value: overview.value.documents.total,
                    tone: "slate"
                  }, null, 8, ["icon", "value"]),
                  _createVNode(KpiCard, {
                    icon: _unref(Inbox),
                    label: "Courriers arrivés",
                    value: overview.value.documents.arrives_total,
                    tone: "indigo"
                  }, null, 8, ["icon", "value"]),
                  _createVNode(KpiCard, {
                    icon: _unref(Send),
                    label: "Courriers départ",
                    value: overview.value.documents.departs_total,
                    tone: "violet"
                  }, null, 8, ["icon", "value"]),
                  _createVNode(KpiCard, {
                    icon: _unref(FolderKanban),
                    label: "Affectations actives",
                    value: overview.value.affectations.total,
                    tone: "amber"
                  }, null, 8, ["icon", "value"]),
                  _createVNode(KpiCard, {
                    icon: _unref(ArrowLeftRight),
                    label: "Transferts",
                    value: overview.value.affectations.transferts,
                    tone: "cyan"
                  }, null, 8, ["icon", "value"]),
                  _createVNode(KpiCard, {
                    icon: _unref(Archive),
                    label: "Archivés",
                    value: overview.value.archives.total,
                    tone: "emerald"
                  }, null, 8, ["icon", "value"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", _hoisted_11, [
                    _createVNode(_unref(TrendingUp), { class: "w-5 h-5 text-[#22282F]" }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Progression des courriers (état courant) "))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(ChartBar, {
                      rows: journeyRows.value,
                      color: '#4f46e5'
                    }, null, 8, ["rows"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", _hoisted_15, [
                      _createVNode(_unref(Inbox), { class: "w-5 h-5 text-[#22282F]" }),
                      _cache[7] || (_cache[7] = _createTextVNode(" Courriers par étape ")),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(overview.value.documents.arrives_total), 1)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-3" }, "État courant des courriers arrivés", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      (hasStageData.value)
                        ? (_openBlock(), _createBlock(_unref(Doughnut), {
                            key: 0,
                            data: stageDonutData.value,
                            options: donutOptions
                          }, null, 8, ["data"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, " Aucune donnée "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h3", _hoisted_20, [
                      _createVNode(_unref(Send), { class: "w-5 h-5 text-[#22282F]" }),
                      _cache[9] || (_cache[9] = _createTextVNode(" Notes par statut ")),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(overview.value.documents.departs_total), 1)
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-3" }, "État courant des courriers départ", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(ChartDonut, { rows: noteStatusRows.value }, null, 8, ["rows"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h3", _hoisted_24, [
                    _createVNode(_unref(Search), { class: "w-5 h-5 text-[#22282F]" }),
                    _cache[11] || (_cache[11] = _createTextVNode(" Moteur de recherche d'archives ")),
                    _createElementVNode("span", {
                      class: _normalizeClass(['ml-auto inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
                           overview.value.recherche.operationnel ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-gray-100 text-gray-500 border border-gray-200'])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['w-2 h-2 rounded-full', overview.value.recherche.operationnel ? 'bg-emerald-500' : 'bg-gray-400'])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(overview.value.recherche.operationnel ? 'Opérationnel' : 'Aucune recherche sur la période'), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(MiniStat, {
                      label: "Recherches",
                      value: overview.value.recherche.total
                    }, null, 8, ["value"]),
                    _createVNode(MiniStat, {
                      label: "Latence moyenne",
                      value: overview.value.recherche.latence_moyenne_ms + ' ms'
                    }, null, 8, ["value"]),
                    _createVNode(MiniStat, {
                      label: "Sans résultat",
                      value: overview.value.recherche.sans_resultat_pct + ' %'
                    }, null, 8, ["value"]),
                    _createVNode(MiniStat, {
                      label: "Recherches IA",
                      value: overview.value.recherche.ai
                    }, null, 8, ["value"])
                  ])
                ]),
                (courriers.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(ChartCard, {
                        title: "Qui a importé",
                        icon: _unref(Upload)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ChartBar, {
                            horizontal: "",
                            rows: actorRows(courriers.value.par_importateur),
                            color: '#0891b2'
                          }, null, 8, ["rows"])
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(ChartCard, {
                        title: "Par ambassade",
                        icon: _unref(Building2)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ChartBar, {
                            horizontal: "",
                            rows: (courriers.value.par_ambassade || []),
                            color: '#7c3aed'
                          }, null, 8, ["rows"])
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(ChartCard, {
                        title: `Envoyés au SG (${courriers.value.envoyes_sg.total})`,
                        icon: _unref(Send)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ChartBar, {
                            horizontal: "",
                            rows: actorRows(courriers.value.envoyes_sg.par_acteur),
                            color: '#d97706'
                          }, null, 8, ["rows"])
                        ]),
                        _: 1
                      }, 8, ["title", "icon"]),
                      _createVNode(ChartCard, {
                        title: `Envoyés à l'ambassadeur (${courriers.value.envoyes_ambassadeur.total})`,
                        icon: _unref(Send)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ChartBar, {
                            horizontal: "",
                            rows: actorRows(courriers.value.envoyes_ambassadeur.par_acteur),
                            color: '#059669'
                          }, null, 8, ["rows"])
                        ]),
                        _: 1
                      }, 8, ["title", "icon"]),
                      (courriers.value.envoyes_directeur)
                        ? (_openBlock(), _createBlock(ChartCard, {
                            key: 0,
                            title: `Envoyés au directeur (${courriers.value.envoyes_directeur.total})`,
                            icon: _unref(Send)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ChartBar, {
                                horizontal: "",
                                rows: actorRows(courriers.value.envoyes_directeur.par_acteur),
                                color: '#2563eb'
                              }, null, 8, ["rows"])
                            ]),
                            _: 1
                          }, 8, ["title", "icon"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  (departs.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("h3", _hoisted_29, [
                          _createVNode(_unref(FileText), { class: "w-5 h-5 text-[#22282F]" }),
                          _createTextVNode(" Courriers départ (" + _toDisplayString(departs.value.total) + ") ", 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-2" }, "Par type de document", -1)),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(ChartDonut, {
                              rows: departs.value.par_type.map(r => ({ label: r.type, count: r.count }))
                            }, null, 8, ["rows"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (affectations.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("h3", _hoisted_32, [
                          _createVNode(_unref(FolderKanban), { class: "w-5 h-5 text-[#22282F]" }),
                          _createTextVNode(" Affectations actives (" + _toDisplayString(affectations.value.total) + ") ", 1)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-4" }, "Niveau affectation", -1)),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-2" }, "Par statut", -1)),
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(ChartDonut, { rows: affectationStatusRows.value }, null, 8, ["rows"])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-2" }, "Par direction", -1)),
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(ChartBar, {
                                horizontal: "",
                                rows: (affectations.value.par_direction || []),
                                color: '#22282F'
                              }, null, 8, ["rows"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_unref(AlertCircle), { class: "w-16 h-16 text-dashboard-muted mx-auto mb-4" }),
                _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-lg font-semibold text-dashboard-text mb-2" }, "Aucune donnée disponible", -1)),
                _createElementVNode("button", {
                  onClick: reload,
                  class: "px-4 py-2 bg-[#22282F] text-white rounded-lg hover:bg-[#2a3139] transition-colors mt-2"
                }, " Réessayer ")
              ]))
      ]),
      _createVNode(ExportModal, {
        open: showExport.value,
        overview: overview.value,
        courriers: courriers.value,
        departs: departs.value,
        affectations: affectations.value,
        params: currentParams.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showExport.value = false)),
        onDone: onExportDone
      }, null, 8, ["open", "overview", "courriers", "departs", "affectations", "params"])
    ]),
    _: 1
  }))
}
}

})